// Data for flyers and brochures

export const flyersandbrochures = [
  {
    id : 1,
    businessname: 'Harsha Electronics',
    title: 'Harshotsava Anniversary Celebrations',
    imagepath: '/images/flyersimages/harsha_anniversary_brochure_e1.jpg',
    description: 'Up to 25% off on electronics items from 9th March to 15th March only!',
    location: 'Mangalore/Udupi/Kundapur',
    featured: true,
    dateposted: '2026-03-10T10:00:00Z',
    listorder: 1,
    accountstatus: 'A',
  },
  {
    id : 2,
    businessname: 'Pai Electronics',
    title: 'Anniversary Celebrations',
    imagepath: '/images/flyersimages/pai_anniversary_brochure_e1.jpg',
    description: 'Win upto 5 crores loyalty points! Save on electronics items from 7th March to 16th March only!',
    location: 'Mangalore/Udupi/Kundapur',
    featured: true,
    dateposted: '2026-03-10T10:00:00Z',
    listorder: 1,
    accountstatus: 'A',
  },
  {
    id : 3,
    businessname: 'blackfridaydeals.com',
    title: 'Black Friday Deals',
    imagepath: '/images/flyersimages/blackfridaydeals.jpg',
    description: 'Don’t miss the biggest discounts of the year!',
    location: 'Mangalore',
    featured: true,
    dateposted: '2026-03-10T10:00:00Z',
    listorder: 2,
    accountstatus: 'A',
  },
  {
    id : 4,
    businessname: 'SuperMart',
    title: 'Save More on Groceries',
    imagepath: '/images/flyersimages/savemoregrocery.jpeg',
    description: 'Don’t miss the biggest discounts of the year!',
    location: 'Udupi',
    featured: true,
    dateposted: '2026-03-10T10:00:00Z',
    listorder: 3,
    accountstatus: 'A',
  },
  {
    id : 5,
    businessname: 'ShopEasy Inc',
    title: 'Black Friday Deals',
    imagepath: '/images/flyersimages/salesGeneral.avif',
    description: 'Don’t miss the biggest discounts of the year!',
    location: 'Mangalore',
    featured: true,
    dateposted: '2026-03-10T10:00:00Z',
    listorder: 4,
    accountstatus: 'A',

  },
  {
    id : 6,
    businessname: 'India Bazaar',
    title: 'Festive Deals',
    imagepath: '/images/flyersimages/supersale_grocery.jpg',
    description: 'Massive discounts on groceries & seasonal items!',
    location: 'Mangalore',
    featured: true,
    dateposted: '2026-03-10T10:00:00Z',
    listorder: 5,
    accountstatus: 'A',
  },
  {
    id : 7,
    businessname: 'New Chennai Shopping',
    title: 'Festive Deals',
    imagepath: '/images/flyersimages/kundapura_newshoppingchennai_e1.jpg',
    description: 'Pick any items Rs 159 only',
    location: 'Kundapur',
    featured: true,
    dateposted: '2026-03-10T10:00:00Z',
    listorder: 3,
    accountstatus: 'A',
  },
];

